import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Chart } from 'chart.js';
import { AnalyticsService } from '../../../../services/analytics.service';
import { Subscription } from 'rxjs';
import { formatHour, getBarChartConfig, PARKBOT_COLORS } from '../../../utils/chart-config';

@Component({
  selector: 'app-card-peak-hour-analysis',
  templateUrl: './card-peak-hour-analysis.component.html'
})
export class CardPeakHourAnalysisComponent implements OnInit, AfterViewInit, OnDestroy {
  peakData: any;
  chart: Chart;
  subscription: Subscription;
  loadingSubscription: Subscription;
  isLoading = false;
  
  constructor(private analyticsService: AnalyticsService) { }

  ngOnInit(): void {
    // Subscribe to loading state
    this.loadingSubscription = this.analyticsService.loading$
      .subscribe(loading => {
        this.isLoading = loading;
      });

    this.subscription = this.analyticsService.getPeakHourAnalysis()
      .subscribe(data => {
        this.peakData = data;
        if (this.chart) {
          this.updateChart();
        }
      });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initChart();
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
    
    if (this.chart) {
      this.chart.destroy();
    }
  }

  formatHour(hour: number): string {
    return formatHour(hour);
  }

  private initChart(): void {
    if (!this.peakData) return;
    
    const canvas = document.getElementById('peak-hour-chart') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const labels = Array.from({ length: 24 }, (_, i) => formatHour(i));
    
    const datasets = [
      {
        label: 'Entries',
        backgroundColor: PARKBOT_COLORS.primary,
        borderColor: PARKBOT_COLORS.primary,
        data: this.peakData.hourCounts.map(hour => hour.entries),
        barPercentage: 0.6,
        categoryPercentage: 0.7,
      },
      {
        label: 'Exits',
        backgroundColor: PARKBOT_COLORS.info,
        borderColor: PARKBOT_COLORS.info,
        data: this.peakData.hourCounts.map(hour => hour.exits),
        barPercentage: 0.6,
        categoryPercentage: 0.7,
      },
      {
        label: 'Occupancy',
        backgroundColor: PARKBOT_COLORS.success,
        borderColor: PARKBOT_COLORS.success,
        data: this.peakData.hourCounts.map(hour => hour.occupancy),
        barPercentage: 0.6,
        categoryPercentage: 0.7,
        type: 'line',
        fill: false,
        tension: 0.4
      }
    ];

    const config = getBarChartConfig(labels, datasets);
    this.chart = new Chart(ctx, config);
  }

  private updateChart(): void {
    if (!this.chart || !this.peakData) return;
    
    this.chart.data.datasets[0].data = this.peakData.hourCounts.map(hour => hour.entries);
    this.chart.data.datasets[1].data = this.peakData.hourCounts.map(hour => hour.exits);
    this.chart.data.datasets[2].data = this.peakData.hourCounts.map(hour => hour.occupancy);
    
    this.chart.update();
  }
}
